class GalleryBoard extends HTMLElement {
  constructor() {
    super();
    this.visibleCount = parseInt(this.dataset.mobileVisible) || 10;
    this.cards = Array.from(this.querySelectorAll('.gallery-board__card'));
    this.grid = this.querySelector('.gallery-board__grid');
    this.loadMoreBtn = this.querySelector('.gallery-board__load-more');
    this.showLessBtn = this.querySelector('.gallery-board__show-less');
    this.isMobile = window.innerWidth < 768;

    this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
  }

  connectedCallback() {
    this.initLayout();
    window.addEventListener('resize', this.debouncedResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedResize);
  }

  initLayout() {
    this.isMobile = window.innerWidth < 768;
    this.resetGrid();

    if (this.isMobile) {
      this.wrapCardsForMobile();
      this.setupLoadMore();
    } else {
      this.cards.forEach(card => this.grid.appendChild(card));
      this.loadMoreBtn?.classList.add('hidden');
      this.showLessBtn?.classList.add('hidden');
    }
  }

  handleResize() {
    const nowMobile = window.innerWidth <= 768;
    if (nowMobile !== this.isMobile) {
      this.initLayout();
    }
  }

  resetGrid() {
    this.grid.innerHTML = '';
    this.cards.forEach(card => this.grid.appendChild(card));
  }

  wrapCardsForMobile() {
    const initialWrapper = document.createElement('div');
    initialWrapper.classList.add('gallery-board__wrapper', 'gallery-board__mobile-initial');

    const loadMoreWrapper = document.createElement('div');
    loadMoreWrapper.classList.add('gallery-board__wrapper', 'gallery-board__mobile-extra');
    loadMoreWrapper.style.display = 'none';

    this.cards.forEach((card, index) => {
      if (index < this.visibleCount) {
        initialWrapper.appendChild(card);
      } else {
        loadMoreWrapper.appendChild(card);
      }
    });

    this.grid.innerHTML = '';
    this.grid.appendChild(initialWrapper);
    this.grid.appendChild(loadMoreWrapper);

    this.initialWrapper = initialWrapper;
    this.loadMoreWrapper = loadMoreWrapper;
  }

  setupLoadMore() {
    if (!this.loadMoreBtn || !this.showLessBtn || !this.loadMoreWrapper) return;

    this.loadMoreBtn.classList.remove('hidden');
    this.showLessBtn.classList.add('hidden');

    this.loadMoreBtn.onclick = () => {
      const extraCards = Array.from(this.loadMoreWrapper.children);
      this.loadMoreWrapper.style.display = 'block';

      extraCards.forEach((card, index) => {
        card.classList.add('gallery-board__fade-in');
        card.style.animationDelay = `${index * 20}ms`;
      });

      this.loadMoreBtn.classList.add('hidden');
      this.showLessBtn.classList.remove('hidden');
    };

    this.showLessBtn.onclick = () => {
      this.loadMoreWrapper.style.display = 'none';
      this.loadMoreBtn.classList.remove('hidden');
      this.showLessBtn.classList.add('hidden');
      this.scrollIntoView({ behavior: 'smooth' });
    };
  }

  debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }
}

if (!customElements.get("gallery-board")) {
  customElements.define("gallery-board", GalleryBoard);
}
